import type { Locale } from "popopo-msg/routes"

export interface SimplePageMessages {
  badRequest: {
    title: string
    description: string
    backButton: string
  }
  notFound: {
    title: string
    description: string
    backButton: string
  }
  serverError: {
    title: string
    description: string
    backButton: string
  }
  serviceUnavailable: {
    title: string
    description: string
    backButton: string
  }
  publicLanding: {
    titleLine1: string
    titleLine2: string
    description: string
    openAppButton: string
  }
  mobileAppBanner: {
    appName: string
    subtitle: string
    openButton: string
  }
}

export const messages: Record<Locale, SimplePageMessages> = {
  ja: {
    badRequest: {
      title: "不正なリクエスト",
      description: "リクエストが正しくありません。URLをご確認ください。",
      backButton: "トップページに戻る",
    },
    notFound: {
      title: "ページが見つかりませんでした",
      description: "お探しのページは存在しないか、削除された可能性があります",
      backButton: "トップページに戻る",
    },
    serverError: {
      title: "ページを表示できませんでした",
      description: "サーバーエラーのため リクエストを実行できませんでした",
      backButton: "トップページに戻る",
    },
    serviceUnavailable: {
      title: "サービス一時停止中",
      description: "現在、サービスが一時的に利用できません。しばらくしてからもう一度お試しください。",
      backButton: "トップページに戻る",
    },
    publicLanding: {
      titleLine1: "POPOPOアプリを開いて",
      titleLine2: "続けてください",
      description: "",
      openAppButton: "POPOPOアプリを開く",
    },
    mobileAppBanner: {
      appName: "POPOPO",
      subtitle: "POPOPOアプリで開く",
      openButton: "開く",
    },
  },
  en: {
    badRequest: {
      title: "Bad Request",
      description: "The request was invalid. Please check the URL.",
      backButton: "Back to Home",
    },
    notFound: {
      title: "Page not found",
      description: "The page you are looking for does not exist or may have been deleted",
      backButton: "Back to Home",
    },
    serverError: {
      title: "Could not display page",
      description: "The request could not be completed due to a server error",
      backButton: "Back to Home",
    },
    serviceUnavailable: {
      title: "Service Unavailable",
      description: "The service is temporarily unavailable. Please try again later.",
      backButton: "Back to Home",
    },
    publicLanding: {
      titleLine1: "Open the POPOPO app",
      titleLine2: "to continue",
      description: "",
      openAppButton: "Open POPOPO App",
    },
    mobileAppBanner: {
      appName: "POPOPO",
      subtitle: "Open in POPOPO app",
      openButton: "Open",
    },
  },
  ko: {
    badRequest: {
      title: "잘못된 요청",
      description: "요청이 올바르지 않습니다. URL을 확인해 주세요.",
      backButton: "홈으로 돌아가기",
    },
    notFound: {
      title: "페이지를 찾을 수 없습니다",
      description: "찾고 계신 페이지가 존재하지 않거나 삭제되었을 수 있습니다",
      backButton: "홈으로 돌아가기",
    },
    serverError: {
      title: "페이지를 표시할 수 없습니다",
      description: "서버 오류로 인해 요청을 실행할 수 없습니다",
      backButton: "홈으로 돌아가기",
    },
    serviceUnavailable: {
      title: "서비스 일시 중단",
      description: "현재 서비스를 일시적으로 이용할 수 없습니다. 잠시 후 다시 시도해 주세요.",
      backButton: "홈으로 돌아가기",
    },
    publicLanding: {
      titleLine1: "POPOPO 앱을 열어",
      titleLine2: "계속하세요",
      description: "",
      openAppButton: "POPOPO 앱 열기",
    },
    mobileAppBanner: {
      appName: "POPOPO",
      subtitle: "POPOPO 앱에서 열기",
      openButton: "열기",
    },
  },
}

export function getMessages(locale: Locale): SimplePageMessages {
  return messages[locale] ?? messages.ja
}
